import { mindBoxSDK } from '..'
import { useParams, usePathname } from 'next/navigation'
import { useEffect } from 'react'

import { useSession } from '@/entities/session'

import { waitForCookie } from '@/shared/lib/utils/cookies/wait-for-cookie'
import { getPhoneFromJwtToken } from '@/shared/lib/utils/jwt/get-phone-from-jwt-token'

const DEVICE_FOR_ADDITIONAL = [`iphone`, `mac`, `apple-watch`, `ipad`, `airpods`]

export const useServicePageView = (callingFrom: string, sum?: number) => {
	const { currentSession } = useSession()
	const pathname = usePathname()
	const params = useParams()

	useEffect(() => {
		if (pathname) {
			const mobilePhone = getPhoneFromJwtToken(currentSession?.token)
			const urlPage = typeof window !== 'undefined' ? window.location.origin : ''
			const payload = {
				mobilePhone,
				callingFrom,
				sum,
				// @ts-ignore
				additionalInformation: getAdditionalInfo({ device: params.device as string, model: params.model as string }),
				urlPage
			}

			waitForCookie(`mindboxDeviceUUID`)
				.then(() => mindBoxSDK.sendServicePageViewEvent(payload))
				// eslint-disable-next-line no-console
				.catch(err => console.warn(err))
		}
	}, [pathname])

	const getAdditionalInfo = (queryRecord: { device?: string; model?: string }) => {
		const { device = null, model = null } = queryRecord
		const isCorrectDevice = device && DEVICE_FOR_ADDITIONAL.includes(device)
		if (!isCorrectDevice) return null
		return `${device}${model ? `/${model}` : ``}`
	}
}
